import * as action from '../action.js';
import reducer from '../reducer.js';
import view from './view.js';

export {action, reducer, view};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/question_set_tag/index.js